jQuery( 'body' ).on('click', 'button.day-number', function (){
		
		if(jQuery(this).hasClass('past')) {
			
		}
		else {
		
		var consultant = jQuery( ".consultant-calendar" ).data('cns');
		var month = jQuery( ".consultant-calendar" ).data('month');
		var day = jQuery( this ).data('day');
		var year = jQuery( ".consultant-calendar" ).data('year');
		
		var timezone = '';
		
		if( jQuery('body').hasClass('page-template-template-sign-up') ) { 
			timezone = jQuery( '#input_1_7' ).val();
		}
		
		if( jQuery('body').hasClass('page-template-template-add-another-student') ) { 
			timezone = jQuery( '#input_5_17' ).val();
		}
		
		if( jQuery('body').hasClass('page-template-template-calendar-availability') ) { 
			timezone = jQuery( '.consultant-banner' ).data('timezone');
		}
		
		
		print_consultant_calendar( consultant, month, day, year, timezone );
				
		}
			
});

jQuery( 'body' ).on('click', 'button.time-block', function (){

	if( jQuery(this).hasClass('pending') ||  jQuery(this).hasClass('accepted') ||  jQuery(this).hasClass('rescheduled') ||  jQuery(this).hasClass('denied ') ) {
	
		//do nothing
		
	}
	
	else {
		
		//alert('good');
		
		if( jQuery('body').hasClass('page-template-template-calendar-availability') ) {
						
			if( jQuery( this ).hasClass( 'selected' ) ) {
				
				jQuery( this ).removeClass('selected');		
				
			}
			
			else {
				
				jQuery( this ).addClass('selected');		
				
			}
			
			sync_blocks();
		
		}
	
		if( jQuery('body').hasClass('page-template-template-consultation-appointments') ) {
			
			if( jQuery( this ).hasClass( 'available' ) ) {
				
				jQuery('.reschedule-to').removeClass('reschedule-to');
				
				jQuery( this ).addClass('reschedule-to');
				
				sync_blocks();
			
			}
		
		}
	
	}
	
	jQuery(this).blur();

	
});

function sync_blocks() {
	
	var selected = [];
	
	jQuery( "button.time-block" ).each( function( index ) {
		
		var consultant = jQuery( ".consultant-calendar" ).data('cns');
		var month = jQuery( ".consultant-calendar" ).data('month');
		var time = jQuery( this ).data('time');
		var day = jQuery( ".consultant-calendar" ).data('day');
		var year = jQuery( ".consultant-calendar" ).data('year');
		var id = jQuery( this ).data('id');
		var select = 'no';
		
		
		if( jQuery(this).hasClass( 'selected' ) ) {
			
			select = 'yes';
		
		}
		
		var keys = ['consultant', 'month', 'day', 'year', 'time', 'id', 'select'];
		var values = [consultant, month, day, year, time, id, select];
		
		var result = {};
		
		keys.forEach((key, i) => result[key] = values[i]);		
		
		selected.push( result );
	
	});
	
	var json = JSON.stringify( selected );
	
	jQuery( "#selected" ).val( json );

	
}

jQuery( 'body' ).on('click', '.update-availability > .button', function (){
					
	 update_availability();
	
});

jQuery( 'body' ).on('click', '.calendar-head button', function () {
	
	var consultant = jQuery( ".consultant-calendar" ).data('cns');
	var month = jQuery( ".consultant-calendar" ).data('month');
	var year = jQuery( ".consultant-calendar" ).data('year');
	
	var timezone = '';
		
	if( jQuery('body').hasClass('page-template-template-sign-up') ) { 
		timezone = jQuery( '#input_1_7' ).val();
	}
		
	if( jQuery('body').hasClass('page-template-template-add-another-student') ) { 
		timezone = jQuery( '#input_5_17' ).val();
	}
		
	if( jQuery('body').hasClass('page-template-template-calendar-availability') ) { 
		timezone = jQuery( '.consultant-banner' ).data('timezone');
	}

			
	if( jQuery(this).hasClass('next') ) {
				
		if( month == '12' ) {
		
			year = parseInt(year) + 1;
			month = '01';
			
			alert(year);
		
		}
		
		else {
			
			month = parseInt(month) + 1;
			//month = "0" + month;
			
			if( parseInt( month ) < 10 ) {
				
				month = "0" + month;
				
			}
			
		}
		
	}

	if( jQuery(this).hasClass('previous') ) {
		
		if( month == '1' ) {
		
			year = parseInt(year) - 1;
			month = '12';

		}
		
		else {
			
			month = parseInt(month) - 1;
			
			if( parseInt( month ) < 10 ) {
				
				month = "0" + month;
				
			}
			
		}
		
	}
	
	change_month( consultant, month, year, timezone );
	
});